export const BASE_URL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_DEV_MODE
    : process.env.REACT_APP_PRO_MODE;
export const AUTH_URL = BASE_URL + "/auth";
export const GENERAL_URL = BASE_URL + "/web/general";
export const DASHBOARD_URL = BASE_URL + "/web/dashboard";
export const USER_URL = BASE_URL + "/user";
export const WEB_USER_URL = BASE_URL + "/web/users";
export const CUSTOMER_URL = BASE_URL + "/web/customers";
export const LOCATION_URL = BASE_URL + "/web/locations";
export const FLAT_URL = BASE_URL + "/web/flats";
export const FLAT_ITEMS_URL = BASE_URL + "/web/flats-items";
export const FLOOR_URL = BASE_URL + "/web/floors";
export const ROOM_URL = BASE_URL + "/web/rooms";
export const ROOM_ITEMS_URL = BASE_URL + "/web/room-items";
export const OFFERS_URL = BASE_URL + "/web/offers";
export const OFFER_NOTES_URL = BASE_URL + "/web/offer-notes";
export const EVENTS_URL = BASE_URL + "/web/events";
export const ROOM_NAMES_URL = BASE_URL + "/admin/room-names/room-name";
export const COMMON_LISTS_URL = BASE_URL + "/web/common-lists";
export const NOTIFICATIONS_URL = BASE_URL + "/web/notifications";
export const TRADE_CONTACT_URL = BASE_URL + "/web/trade-contacts";
export const FLAT_TRADE_CONTACT_URL = BASE_URL + "/web/flat-trade-contacts";
export const CUSTOMER_TYPE_URL = COMMON_LISTS_URL + "/customer-types";
export const FLAT_JOB_MATERIAL_URL = BASE_URL + "/web/flats-jobs-materials";
export const ROOM_IMAGES_URL = BASE_URL + "/web/rooms/images";
export const PROJECT_MATERIALS_URL = BASE_URL + "/web/project-materials/project";
export const VISITS_URL = BASE_URL + "/web/visits";
export const CONTACT_PERSONS_URL = BASE_URL + "/web/contact-persons";
export const TASKS_URL = BASE_URL + "/web/tasks";
export const PLAN_SCAN_URL = BASE_URL + "/web/plan-scan";
